/**
 * Where the API lives. In production the API is served from the same Vercel
 * deployment (`/api/*`), so the base is the current origin. In development the
 * Express server runs separately on :3001. REACT_APP_API_URL overrides both.
 */
export const API_BASE: string =
  process.env.REACT_APP_API_URL ?? (process.env.NODE_ENV === 'development' ? 'http://localhost:3001' : '');
